module.exports = __webpack_public_path__ + "static/media/gt800-vehicle-tracker-1.a91a058d.png";